import SMBookedGame from "./SMBookedGame";

export default SMBookedGame;